/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, rank: NonNullable<unknown> }} Directory_Vibebids_Claimed_RankInputs */

const en_directory_vibebids_claimed_rank = /** @type {(inputs: Directory_Vibebids_Claimed_RankInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} claimed #${i?.rank}`)
};

const zh_directory_vibebids_claimed_rank = /** @type {(inputs: Directory_Vibebids_Claimed_RankInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} 抢占了 #${i?.rank}`)
};

/**
* | output |
* | --- |
* | "{name} claimed #{rank}" |
*
* @param {Directory_Vibebids_Claimed_RankInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_claimed_rank = /** @type {((inputs: Directory_Vibebids_Claimed_RankInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Claimed_RankInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_claimed_rank(inputs)
	return zh_directory_vibebids_claimed_rank(inputs)
});
export { directory_vibebids_claimed_rank as "directory.vibebids.claimed_rank" }